const styles = {
  closeButton: {
    marginTop: 10,
    marginLeft: 10,
  },
  panel: {
    margin: 0,
    padding: 0,
    width: 539,
    height: "100vh",
    borderRadius: 5,
    minHeight: 700,
    position: 'absolute',
    right: 0,
    // ! the only zIndex
    zIndex: 15,
  },
};

export default styles;
